var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  KamiSama: () => KamiSama
});
var import_samaForm = __toModule(require("./samaForm/samaForm"));
var import_samaData = __toModule(require("./samaData/samaData"));
var import_utils = __toModule(require("../utils"));
var import_definition2 = __toModule(require("./definition"));
var import_yayoyaki = __toModule(require("./yayoyaki"));
var import_constants = __toModule(require("./constants"));
var import_userCardCache = __toModule(require("./samaCache/userCache/userCardCache"));
var import_yayoyakiValidator = __toModule(require("./yayoyakiValidator"));
var import_cardGroup = __toModule(require("./card/cardGroup"));
const _KamiSama = class {
  constructor(userDataInitial, userData, samaDictionary, userCardsCache = {}, startScreen = _KamiSama.DEFAULT_SCREEN_ID) {
    this.verifyConstructionArgsAreValid({
      userData,
      userDataInitial,
      samaDictionary
    });
    this.samaForm = new import_samaForm.SamaForm((0, import_utils.cloneDeep)(samaDictionary));
    this.samaData = new import_samaData.SamaData((0, import_utils.cloneDeep)(userDataInitial), (0, import_utils.cloneDeep)(userData), new import_userCardCache.UserCardCache((0, import_utils.cloneDeep)(userCardsCache)));
    this.current = this.samaForm.getScreen(this.samaData, startScreen);
    this.setUserData(userData);
    this.setUserDataInitial(userDataInitial);
  }
  verifyConstructionArgsAreValid(args) {
    const { userData, userDataInitial, samaDictionary } = args;
    if (!userData) {
      throw new Error("KamiSama cannot be initialized without user data");
    }
    if (!userDataInitial) {
      throw new Error("KamiSama cannot be initialized without user data initial");
    }
    if (!samaDictionary) {
      throw new Error("KamiSama cannot be initialized without sama dictionary");
    }
  }
  getForm() {
    return (0, import_utils.cloneDeep)(this.samaForm.getForm());
  }
  getScreen(screenId, childIndex) {
    this.current = this.samaForm.getScreen(this.samaData, screenId, childIndex);
    return this.current;
  }
  getScreenCurrent() {
    return this.current;
  }
  getScreenNext(screen) {
    this.current = this.samaForm.getScreenNext(this.samaData, screen);
    return this.current;
  }
  getScreenPrevious(screen) {
    this.current = this.samaForm.getScreenPrevious(this.samaData, screen);
    return this.current;
  }
  getSectionsOrdered() {
    return this.samaForm.getSectionsOrdered();
  }
  getSectionsValidation() {
    const sections = this.samaForm.getSections();
    const sectionValidation = {};
    for (const section of sections) {
      sectionValidation[section] = {};
      const yayoyakis = this.samaForm.getYayoyakisForSection(section);
      for (const yayoyakiForm of yayoyakis) {
        const isValid = import_yayoyaki.Yayoyaki.isValid(this.samaData, this.samaForm, yayoyakiForm).every((isValid2) => isValid2);
        sectionValidation[section].isValid = sectionValidation[section].isValid === void 0 ? isValid : sectionValidation[section].isValid && isValid;
      }
    }
    return sectionValidation;
  }
  getHiddenSections() {
    return this.samaForm.getSections().filter((section) => {
      const screenForm = this.samaForm.getScreenForm(`${section}_${import_definition2.ScreenTypes.START}`);
      return (screenForm == null ? void 0 : screenForm.requirement) && !import_yayoyakiValidator.YayoyakiValidator.validateRequirements(this.samaData.getUserData(), screenForm == null ? void 0 : screenForm.requirement);
    }).map((section) => section);
  }
  getUserData() {
    return (0, import_utils.cloneDeep)(this.samaData.getUserData());
  }
  getUserCardsCache() {
    return this.samaData.getUserCardsCache().getValues();
  }
  setForm(samaForm) {
    const senninFormCopy = (0, import_utils.cloneDeep)(samaForm);
    this.samaForm.setForm(senninFormCopy);
  }
  setUserData(userData) {
    const userDataCopy = (0, import_utils.cloneDeep)(userData);
    this.samaData.setUserData(userDataCopy);
    this.samaData.sanitizeValues(this.samaForm.getYayoyakis());
  }
  setUserDataInitial(userDataInitial) {
    const userDataInitialCopy = (0, import_utils.cloneDeep)(userDataInitial);
    this.samaData.setUserDataInitial(userDataInitialCopy);
  }
  setUserCardsCache(userCardsCache) {
    const userCardsCacheCopy = (0, import_utils.cloneDeep)(userCardsCache);
    this.samaData.setUserCardsCache(new import_userCardCache.UserCardCache(userCardsCacheCopy));
  }
  deleteEmptyCards() {
    Object.keys(this.samaForm.getCardMap()).forEach((cardId) => {
      const cardGroup = this.samaForm.getCardForm(cardId);
      const card = new import_cardGroup.CardGroup(this.samaData, this.samaForm, cardGroup, "");
      card.deleteEmptyCards();
    });
  }
};
let KamiSama = _KamiSama;
KamiSama.DEFAULT_SCREEN_ID = import_constants.screensId.PERSONAL_START;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  KamiSama
});
